<template>
  <form-section
    id="company-input"
    :headline="this.$t('form.parties.company.headline')"
  >
    <textfield
      id="company_name"
      :label="$t('form.parties.company.name.label')"
      :placeholder="$t('form.parties.company.name.placeholder')"
      v-model="company.name"
      isRequired
      v-on:focus="scrollTo('#parties')"
    />

    <textfield
      id="company_address"
      :label="$t('form.parties.company.address.label')"
      :placeholder="$t('form.parties.company.address.placeholder')"
      v-model="company.address"
      isRequired
      v-on:focus="scrollTo('#parties')"
    />

    <div class="form-group">
      <label for="company_cvr">{{
        $t("form.parties.company.cvr.label")
      }}</label>
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          id="company_cvr"
          maxlength="8"
          minlength="8"
          :placeholder="$t('form.parties.company.cvr.placeholder')"
          v-model="company.cvr"
          @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
          @blur="validateRequired"
          required
          v-on:focus="scrollTo('#parties')"
        />
        <div class="invalid-feedback">
          <invalid-cross></invalid-cross>
          <span>{{ $t("form.shared.cvr_error") }}</span>
        </div>
      </div>
    </div>
  </form-section>
</template>

<script>
import Textfield from "@/shared/components/Textfield.vue";
import FormSection from "@/shared/components/FormSection.vue";
export default {
  components: {
    Textfield,
    FormSection,
  },
  data() {
    return {
      company: {
        name: "",
        address: "",
        cvr: "",
      },
    };
  },
  watch: {
    company: {
      handler() {
        this.company.cvr = this.restrictNumber(this.company.cvr);
        this.$store.commit("updateCompany", this.company);
      },
      deep: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/apps/hemmelig/components/form/parties/CompanyInput.vue